exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HDLVBVBs4mWoi_{padding:4px;margin-bottom:4px;border-bottom:1px solid rgba(9,30,66,.13)}._1P-KdP3fUGy5Tm h3,._1P-KdP3fUGy5Tm p{margin:0 0 8px}.yRMsF6kWI-BjMg,.yRMsF6kWI-BjMg a{color:#5e6c84}.yRMsF6kWI-BjMg a:not(._38uVdHlQFmBXme):hover{color:#172b4d}._2fHYSG3WrmntS6{background-color:#e9e9e9}._2vPLkoBnm0rqqz{text-decoration:none}._2vPLkoBnm0rqqz:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"announcement": "HDLVBVBs4mWoi_",
	"announcement-blog": "_1P-KdP3fUGy5Tm",
	"quiet": "yRMsF6kWI-BjMg",
	"disabled": "_38uVdHlQFmBXme",
	"announcement-downtime": "_2fHYSG3WrmntS6",
	"announcementHeaderLink": "_2vPLkoBnm0rqqz"
};